import { Button, Checkbox, Form, Input } from "antd";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { ModalSuspend } from "../modal";
import LayoutLogin from "../layoutLogin";
import { useAPIPublic } from "../../../tools/api";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { _adr, _ckey } from "../../../address";
import { app_Cookie_Remove, setAuthorization, setSessionStorage, setToken } from "../../../tools/services";

import { useDispatch } from "react-redux";
import { globalValue } from "../../../reducer/serviceReducerGlobala";
import { convertPersian, isEmpty, validateInput, waitForCaptchaLoad } from "../../../tools/tools";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import Loading from "../../auxiliary/loader/loading";
const Login = () => {
	const [t] = useTranslation("global");
	const { login, queryCurrentUser, queryUserRoles } = useAPIPublic();
	const nav = useNavigate();
	const dispatch = useDispatch();
	const [isProgress, setIsProgress] = useState(false);
	const location = useLocation();
	const queryString = new URLSearchParams(location?.search);

	useEffect(() => {
		if (!isEmpty(queryString.get("office")) && !isEmpty(queryString.get("uk")) && !isEmpty(queryString.get("token"))) {
			const param = {
				username: queryString.get("office"),
				password: queryString.get("token"),
				userkey: queryString.get("uk"),
			};
			handleSubmitForm(param, true);
		}
	}, []);

	const handleSubmitForm = async (param) => {
		submitForm(param, false);
	};
	const submitForm = async (param, state = false) => {
		setIsProgress(true);
		const captchaToken = await waitForCaptchaLoad();
		let payload = {
			password: param?.password,
			username: param?.username,
			expiretimebyminute: process.env.REACT_APP_LOGIN_EXPIRE,
			captcha: captchaToken,
			// captcha: "string",
		};
		if (param && param?.userkey) {
			payload.userkey = param.userkey;
		}
		let response = await login(payload);
		if (response) {
			if (state) {
				setSessionStorage("userDealer", "pishkhan");
			}

			await setToken({
				token: response.token,
				expireUTCTime: response.expireUTCTime,
			});
			setAuthorization(response.token);
			if (response?.twofactorenabled) {
				app_Cookie_Remove(_ckey.expiretimeLogin);
				nav(_adr.Root + _adr.Login.OtpConfirm, {
					state: {
						sessionid: response.sessionid,
						expiretime: response.expiretime,
						loginState: true,
						msisdn: response.msisdn,
					},
				});
				//
			} else {
				let resUser = await queryCurrentUser();
				if (resUser) {
					let resRoles = await queryUserRoles();
					if (resRoles) {
						dispatch(globalValue({ _currentUser: { ...resUser, roles: [...resRoles] } }));
						if (!resUser.phonenumberconfirmed) nav(_adr.Root + _adr.Login.ResetPassword, { replace: true });
						else nav(_adr.Root + _adr.Home);
					}
				}
			}
			// if(response.)
		}
		setIsProgress(false);
	};
	return (
		<>
			<LayoutLogin>
				<Form name="normal_login" className="login-form" initialValues={{ username: "", password: "" }} onFinish={handleSubmitForm}>
					<Form.Item name="username" className="input-normal" rules={[validateInput({ t: t, validate: true })]}>
						<Input
							dir="ltr"
							prefix={<i className="icon-user"></i>}
							placeholder={t("form.username")}
							maxLength={64}
							onChange={(e) => {
								e.target.value = convertPersian(e.target.value);
							}}
							autoComplete="off"
							allowClear
						/>
					</Form.Item>
					<Form.Item name="password" rules={[validateInput({ t: t, validate: true })]} className="input-normal">
						<Input.Password
							dir="ltr"
							prefix={<i className="icon-lock-normal"></i>}
							placeholder={t("form.password")}
							maxLength={64}
							onChange={(e) => {
								e.target.value = convertPersian(e.target.value);
							}}
							autoComplete="off"
						/>
					</Form.Item>
					<Form.Item>
						<Form.Item name="remember" valuePropName="checked" noStyle>
							<Checkbox className="checked-normal">{t("form.remember")}</Checkbox>
						</Form.Item>
						<Link className="login-form-forgot" to={_adr.Root + _adr.Login.ForgetPassword}>
							{t("form.forgetpassword")}
						</Link>
					</Form.Item>
					<Form.Item>
						<Button type="default" htmlType="submit" className={`btn-normal btn-aptel ${isProgress && "disabled"}`} disabled={isProgress} danger>
							{isProgress ? t("form.inProgress") : t("form.loginButton")}
						</Button>
					</Form.Item>
				</Form>
				<ModalSuspend action="false" />
			</LayoutLogin>
		</>
	);
};

export default Login;
